var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-block btn-transparent text-left",attrs:{"type":"button"},on:{"click":function($event){return _vm.productoClickSku($event)}}},[_vm._v("\n  "+_vm._s(_vm.producto.sku)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }